import { Button, Form, Input, Spin } from 'antd';
import { useAxiosRequest, useIsDark } from 'common/hooks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SetNewPass from './SetNewPass';

interface countDown {
  countdown: number;
  initialCountdown: number;
  isDisabled: boolean;
}

const VerifyEmail = () => {
  const isDark = useIsDark();
  const [isShow, setIsShow] = useState(false);
  const [countDown, setCountDown] = useState<countDown>({
    countdown: 45,
    initialCountdown: 45,
    isDisabled: true,
  });
  // const email = useSelector((state: any) => state.auth?.profileData?.optEmail);
  const email = useSelector(
    (state: any) => state.auth?.profileData?.otpVerifiedEmail
  );
  const verifyOtp = useAxiosRequest(null);
  const resendOtp = useAxiosRequest(null);
  const [form] = Form.useForm();

  useEffect(() => {
    if (countDown.countdown > 0) {
      const timer = setInterval(() => {
        setCountDown((prev) => ({
          ...prev,
          countdown: prev.countdown - 1,
        }));
      }, 1000);

      return () => clearInterval(timer);
    } else {
      setCountDown((prev) => ({
        ...prev,
        isDisabled: false,
      }));
    }
  }, [countDown.countdown]);


  const handleResendOtp = () => {
    resendOtp.apiAction({
      urlObjKey: 'SendOtpForResetPassword',
      params: { email },
      method: 'POST',
      toastType: 'small',
      cb: () => {
        setCountDown((prev) => ({
          countdown: prev.initialCountdown + 45,
          initialCountdown: prev.initialCountdown + 45,
          isDisabled: true,
        }));
      },
      onError: (error) => {
        console.error('Otp send fail:', error);
      },
    });
  };

  const onFinish = (values: any) => {
    const otp = values?.otp;
    verifyOtp.apiAction({
      urlObjKey: 'VerifyOtp',
      params: { email, otp },
      method: 'POST',
      isToast: true,
      successMessage: 'OTP verification successful!',
      cb: () => {
        // dispatch(setOtpVerifiedEmailAction(email));
        setIsShow(true)
        // navigate(`/${packageName}/signup`);
      },
      onError: (error) => {
        console.error('OTP verification failed:', error);
      },
    });
  };

  return (

    <>
      {
        !isShow ? <Form
          form={form} onFinish={onFinish} autoComplete="off"
          // name="basic"
          // layout="vertical"
          // requiredMark={false}
          // initialValues={{
          //   remember: true,
          // }}
          // onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          // autoComplete="off"
          className='w-full'
        >
          <div className="mb-5 space-y-1">
            <h3 className={`text-xl text-center ${isDark ? 'text-[#CBD5E1]' : ''}`}>
              An OTP has been sent to{' '}
              <span className="font-medium text-green-600">{email}</span>
            </h3>

            <div className="text-primaryColor text-sm flex items-center justify-center gap-1">
              <button
                disabled={countDown.isDisabled || (resendOtp.isLoading && true)}
                onClick={handleResendOtp}
                className="space-x-1"
              >
                <span>Resend OTP </span>{' '}
                {resendOtp.isLoading && (
                  <span>
                    <Spin />
                  </span>
                )}
              </button>{' '}
              <h5 className={` ${!countDown.isDisabled && 'hidden'}`}>
                {' '}
                after {countDown.countdown}s!
              </h5>
            </div>
          </div>
          <div className="flex   flex-col  items-center ">
            <p className={`text-xl font-semibold mb-3 ${isDark ? 'text-white' : ''}`}>Enter OTP</p>
            <Form.Item
              name="otp"
              rules={[
                { required: true, message: 'Please enter the OTP!' },
                {
                  len: 4,
                  message: 'OTP must be 4 characters long.',
                },
              ]}
            >
              <Input.OTP
                size='large'
                length={4}
                onChange={(e: any) =>
                  form.setFieldsValue({
                    otp: e.target.value,
                  })
                }
              />
            </Form.Item>
          </div>
          <Form.Item>
            <Button
              block
              size='large'
              type="primary"
              htmlType="submit"
              className="w-full !bg-primaryColor !text-white"
            >
              Verify Email
            </Button>
          </Form.Item>

        </Form> : <SetNewPass />
      }
    </>



  );
};

export default VerifyEmail;
